<template>
  <v-container pa-0 style="width: 794px;">
    <v-form v-model="valid" lazy-validation ref="form">
      <v-row align="center" justify="center" class="mt-1">
        <v-card width="794">
          <component :isIndividual="isIndividual" ref="templ" :ticketId="ticketId" :ticketInfo="ticketInfo" :isFinished="isFinished" :isOperator="isOperator" v-bind:is="ticketTypes[ticketInfo['ticket_type']['id']].component"></component>
        </v-card>
      </v-row>
      <v-row v-if="!isFinished" align="center" justify="center" class="mt-2">
        <v-btn color="light-blue darken-4" dark @click="validate" width="300" large style="float: right">Сохранить</v-btn>
      </v-row>
    </v-form>
    <request-dialog v-model="searchDialog" message="Выполняется запрос..." />
  </v-container>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  name: 'EditTicket',

  components: {
    TeploTemplate: () => import(
      '@/components/tickets/TeploTemplate'
    ),
    ColdWaterTemplate: () => import(
      '@/components/tickets/ColdWaterTemplate'
    ),
    HotWaterTemplate: () => import(
      '@/components/tickets/HotWaterTemplate'
    ),
    TechTemplate: () => import(
      '@/components/tickets/TechTemplate'
    )
  },

  props: {
    ticketId: {
      type: Number,
      default: undefined
    },
    ticketInfo: {
      default: null
    },
    isFinished: {
      default: false
    },
    isOperator: {
      default: false
    }
  },

  data: () => ({
    searchDialog: false,
    template: null,
    consent: undefined,
    valid: false
  }),

  computed: {
    ...mapGetters({
      ticketTypes: 'common/ticketTypes'
    }),
    isIndividual: function() {
      return this.ticketInfo.is_individual
    }
  },

  created: function() {
    //this.getTicketTemplate()
    //this.getTicketInfo()
  },

  methods: {
    getTicketInfo: async function() {
      this.searchDialog = true
      try {
        const resp = await this.$api.Account.getTicketInfo(this.ticketId)
        this.ticketInfo = resp.data
        // console.log(resp.data)
        this.searchDialog = false
      } catch (e) {
        const err = e
        this.searchDialog = false
        if (e.response.status == 401) {
          await this.$store.dispatch('user/authLogOut')
          location.href = location.href
        }
        let error = 'Не удалось получить информацию о заявке. Попробуйте повторить запрос позднее'
        await this.$store.dispatch('notification/setSystemNotification', { message: error, type: 'error' })
        console.error(e)
      }
    },
    submitTicket: async function() {
      this.searchDialog = true
      try {
        let data = await this.$refs.templ.formData
        if (typeof this.isIndividual === "boolean") {
          data['is_individual'] = this.isIndividual
        } else {
          data['is_individual'] = this.isIndividual == 'true'
        }
        data['ticket_id'] = this.ticketId
        const resp = await this.$api.Account.saveTicket(data)
        location.href = location.href
        //this.$router.push({ path: `/tickets/my_tickets/${resp.data['code']}` })
        this.searchDialog = false
        await this.$store.dispatch('notification/setSystemNotification', { message: 'Изменения сохранены', type: 'message' })
      } catch (e) {
        const err = e
        let error = 'Не удалось сохранить заявку. Попробуйте повторить запрос позднее'
        if (e.response.status == 401) {
          await this.$store.dispatch('user/authLogOut')
          location.href = location.href
        }
        this.searchDialog = false
        await this.$store.dispatch('notification/setSystemNotification', { message: error, type: 'error' })
        console.error(e)
      }
    },
    validate() {
      let isValid = this.$refs.form.validate()
      if (isValid) {
        this.submitTicket()
      }
    },
  }
}
</script>